import { render, staticRenderFns } from "./BusinessTaxForm.vue?vue&type=template&id=39cdb99c&scoped=true&"
import script from "./BusinessTaxForm.vue?vue&type=script&lang=js&"
export * from "./BusinessTaxForm.vue?vue&type=script&lang=js&"
import style0 from "./BusinessTaxForm.vue?vue&type=style&index=0&id=39cdb99c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cdb99c",
  null
  
)

export default component.exports